import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function CatalogoIncentivi() {
  const [incentivi, setIncentivi] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ livello: '', regione: '', tipo: '', search: '' });
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    axios.get('/api/incentivi').then(res => {
      setIncentivi(res.data.incentivi);
      setFiltered(res.data.incentivi);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  useEffect(() => {
    let result = [...incentivi];
    if (filters.livello) result = result.filter(i => i.livello === filters.livello);
    if (filters.regione) result = result.filter(i => i.regione === filters.regione);
    if (filters.tipo) result = result.filter(i => i.tipo === filters.tipo);
    if (filters.search) {
      const s = filters.search.toLowerCase();
      result = result.filter(i => i.nome.toLowerCase().includes(s) || i.descrizione?.toLowerCase().includes(s));
    }
    setFiltered(result);
  }, [filters, incentivi]);

  const livelli = [...new Set(incentivi.map(i => i.livello))];
  const regioni = [...new Set(incentivi.filter(i => i.regione).map(i => i.regione))];
  const tipi = [...new Set(incentivi.map(i => i.tipo))];

  const getBadgeClass = (livello) => {
    if (livello === 'Nazionale') return 'badge-nazionale';
    if (livello === 'Regionale') return 'badge-regionale';
    if (livello === 'Europeo') return 'badge-europeo';
    return 'badge-provinciale';
  };

  return (
    <div className="fade-in">
      <div className="page-header">
        <div className="container">
          <h1>Catalogo Incentivi</h1>
          <p>Esplora tutti gli incentivi disponibili per le imprese italiane, dai bandi regionali ai fondi europei diretti</p>
        </div>
      </div>

      <div className="section">
        <div className="container">
          <div className="filter-bar">
            <input placeholder="Cerca incentivo..." value={filters.search} onChange={e => setFilters({...filters, search: e.target.value})} />
            <select value={filters.livello} onChange={e => setFilters({...filters, livello: e.target.value})}>
              <option value="">Tutti i livelli</option>
              {livelli.map(l => <option key={l} value={l}>{l}</option>)}
            </select>
            <select value={filters.regione} onChange={e => setFilters({...filters, regione: e.target.value})}>
              <option value="">Tutte le regioni</option>
              {regioni.map(r => <option key={r} value={r}>{r}</option>)}
            </select>
            <select value={filters.tipo} onChange={e => setFilters({...filters, tipo: e.target.value})}>
              <option value="">Tutti i tipi</option>
              {tipi.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
            <span style={{ alignSelf: 'center', fontSize: 13, color: '#6b7280' }}>{filtered.length} incentivi trovati</span>
          </div>

          {loading ? (
            <div style={{ textAlign: 'center', padding: 40 }}><div className="spinner" style={{ margin: '0 auto' }}></div></div>
          ) : (
            <div className="grid-3">
              {filtered.map(inc => (
                <div key={inc.id} className="incentivo-card" onClick={() => setSelected(selected?.id === inc.id ? null : inc)} style={{ cursor: 'pointer' }}>
                  <span className={`badge ${getBadgeClass(inc.livello)}`}>
                    {inc.livello}{inc.regione ? ` - ${inc.regione}` : ''}
                  </span>
                  <h3>{inc.nome}</h3>
                  <div className="tipo">{inc.tipo}</div>
                  <div className="desc">{inc.descrizione?.substring(0, 120)}...</div>
                  <div className="meta">
                    <span>{inc.agevolazione}</span>
                    <span>{inc.importo_max}</span>
                  </div>
                  {selected?.id === inc.id && (
                    <div style={{ marginTop: 16, padding: 16, background: '#f9fafb', borderRadius: 8, fontSize: 13 }}>
                      <p><strong>Beneficiari:</strong> {inc.beneficiari}</p>
                      <p><strong>Requisiti:</strong> {inc.requisiti}</p>
                      <p><strong>Scadenza:</strong> {inc.scadenza}</p>
                      <p><strong>Settori:</strong> {inc.settori}</p>
                      {inc.link && <a href={inc.link} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-primary" style={{ marginTop: 8 }}>Maggiori Info</a>}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
